import { noSpecialCharRegex } from '@insify/ui-utils';
import * as yup from 'yup';

import type { TFunction } from 'i18next';

export const validation = (t: TFunction<['common', 'validation', 'funnel']>) => {
  return yup.object().shape({
    address: yup.object().shape({
      postalCode: yup.string().required(t('validation:postal_code_required')),
      city: yup.string().required(t('validation:city_required')),
      street: yup.string().required(t('validation:street_required')),
      houseNumber: yup
        .string()
        .matches(noSpecialCharRegex, t('validation:house_invalid'))
        .required(t('validation:house_required')),
    }),
  });
};
